import { PROCESSING_MESSAGE } from 'config/constants';
import ProcessingRequest from 'components/ProcessingRequest';

const { HEADER, INFO_TEXT, INFO_TEXT_AFTER_10_SECS } = PROCESSING_MESSAGE.CHANGE_DATE;

const ProcessingChangeDate = () => (
  <ProcessingRequest header={HEADER} info={INFO_TEXT} infoAfter10Sec={INFO_TEXT_AFTER_10_SECS} position="fixed" top="0" />
);

export default ProcessingChangeDate;
